import { render, staticRenderFns } from "./Fowlsvalues.vue?vue&type=template&id=45c019ce&"
import script from "./Fowlsvalues.vue?vue&type=script&lang=js&"
export * from "./Fowlsvalues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports